export const tabsFields = [
    {
        label: '合同类型',
    },
    {
        label: '公司'
    }
]